<script>
import appConfig from "@/app.config";
import Layout from "@/layouts/main.vue";

import HelpSupport from "@/components/HelpSupport.vue";
import RecommendationCard from "@/components/recommendation/RecommendationCard.vue";
import GameCoverCard from "@/components/GameCoverCard.vue";
import ColorCard from "@/components/ColorCard.vue";

export default {
  page: {
    title: "Games",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    HelpSupport,
    GameCoverCard,
    RecommendationCard,
    ColorCard,
  },
  data() {
    return {
      assetsPath: appConfig.assetsPath,
      showLoadingScreen: true,
      isMobile: false,
      gameCardData: [],
      dataArrayZh: [
        {
          name: "无尽探索",
          info: "给孩子们提供独特的学习体验，激发好奇心和探索欲。",
          logo: "Rocket.gif",
          isColorCard: true,
          bgColor: "bg-info-color",
        },
        {
          name: "收获创意",
          info: "从绘画和建筑，到探索有趣的地方，再到学习烹饪，每个孩子都能找到适合的玩！",
          logo: "Something for everyone.gif",
          isColorCard: true,
          bgColor: "bg-orange-color",
        },
        {
          name: "欢乐学习 ",
          info: "注重自由玩耍和角色扮演，让孩子拥有解决问题的能力，发展社交技能，倾听故，了解他们生活的世界——所有这些都是在享受乐趣的同时进行的。",
          logo: "Learning fun.gif",
          isColorCard: true,
          bgColor: "bg-green-color",
        },
      ],
      dataArrayEn: [
        {
          name: "Explore",
          info: "We help your child discover unique learning experiences that encourage curiosity and exploration.",
          logo: "Rocket.gif",
          isColorCard: true,
          bgColor: "bg-info-color",
        },
        {
          name: "Get Creative",
          info: "From drawing and building to exploring fun places and cooking, there’s something for everyone!",
          logo: "Something for everyone.gif",
          isColorCard: true,
          bgColor: "bg-orange-color",
        },
        {
          name: "Learning is Fun",
          info: "With a strong focus on free play and role play, kids learn to solve problems, develop social skills, listen to stories, and understand the world they live in – all while having fun.",
          logo: "Learning fun.gif",
          isColorCard: true,
          bgColor: "bg-green-color",
        },
      ],
      gameList: [],
      currentGameList: [],
      featureGame: [], // feature map
      showButton: true,
      gameHeroStyle: {
        backgroundImage:
          "url(" + appConfig.assetsPath + "images/panda-foot-pattern@2x.png)",
      },
    };
  },

  created: function () {
    this.GLOBAL.addEventListener("languageChanged", this.languageChanged);
    this.pageData = window.pageData;
    this.GLOBAL.addEventListener("languageChanged", this.languageChanged);
    this.pageData = window.gamesData;
    this.defaultload();
    if (
      this.pageData &&
      this.pageData.data &&
      this.pageData.data.en.list.length > 0
    ) {
      const gameList = this.pageData.data.en.list.filter(
        (element) => element.isOpen
      );
      this.pageData.data.en.list = gameList;
      this.pageData.data.en.list.splice(0, 0, this.dataArrayEn[0]);
      if (this.pageData.data.en.list.length > 3) {
        this.pageData.data.en.list.splice(5, 0, this.dataArrayEn[1]);
      }
      if (this.pageData.data.en.list.length > 4) {
        this.pageData.data.en.list.splice(7, 0, this.dataArrayEn[2]);
      }
    } else {
      this.pageData.data.en.list.push(...this.dataArrayEn);
    }
    if (
      this.pageData &&
      this.pageData.data &&
      this.pageData.data.zh.list.length > 0
    ) {
      const gameList = this.pageData.data.zh.list.filter(
        (element) => element.isOpen
      );
      this.pageData.data.zh.list = gameList;
      this.pageData.data.zh.list.splice(0, 0, this.dataArrayZh[0]);
      if (this.pageData.data.zh.list.length > 3) {
        this.pageData.data.zh.list.splice(5, 0, this.dataArrayZh[1]);
      }
      if (this.pageData.data.zh.list.length > 4) {
        this.pageData.data.zh.list.splice(7, 0, this.dataArrayZh[2]);
      }
    } else {
      this.pageData.data.zh.list.push(...this.dataArrayZh);
    }
    this.defaultload();
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  mounted() {
    window.addEventListener("resize", this.onResize, { passive: true });
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        window.scrollTo(0, 0);
        this.showLoadingScreen = false;
      }
    };
  },
  updated() {
    this.defaultload();
    console.log("");
  },
  methods: {
    getMoreGames() {
      /** 大于9的情况 */
      if (this.gameList.length - this.currentGameList.length > 9) {
        this.currentGameList = this.currentGameList.concat(
          this.gameList.slice(
            this.currentGameList.length + 1,
            this.currentGameList.length + 10
          )
        );
      } else {
        // 小于等于9的情况
        this.currentGameList = this.gameList;
        this.showButton = false;
      }
    },
    languageChanged(value) {
      let featureGame = [];
      this.gameList = this.pageData.data[value].list;
      Object.keys(this.pageData.data[value].featureGame).forEach((key) => {
        if (key === "town" || key === "learn" || key === "collection") {
          featureGame.push(this.pageData.data[value].featureGame[key]);
          featureGame.reverse();
        }
      });
      if (value === "zh") {
        Object.keys(this.pageData.data[value].featureGame).forEach((key) => {
          if (key === "cc" || key === "ca") {
            featureGame.push(this.pageData.data[value].featureGame[key]);
          }
        });
      }
      this.featureGame = featureGame;
      if (this.gameList && this.gameList.length > 0) {
        if (this.gameList.length > 8) {
          this.currentGameList = this.gameList.slice(0, 9);
        } else {
          this.currentGameList = this.gameList;
        }
        if (this.currentGameList.length === this.gameList.length) {
          this.showButton = false;
        } else {
          this.showButton = true;
        }
      } else {
        this.showButton = false;
      }
    },
    defaultload() {
      this.isMobile = window.innerWidth < 767;
      if (this.isMobile) {
        this.gameCardData = this.$t("games.mobileGameCard");
        // this.dataArray = this.$t("games.mobileDataArray");
      } else {
        this.gameCardData = this.$t("games.gameCardData");
        // this.dataArray = this.$t("games.dataArray");
      }
    },
    onResize() {
      // this.defaultload();
    },
    showMore() {
      this.$t("games.dataArray").forEach((element) => {
        this.dataArray.push(element);
      });
    },
  },
};
</script>

<template>
  <Layout headerStyle="headerDark" :showLoadingScreen="showLoadingScreen">
    <div class="bg-offWhite d-inline-block w-100">
      <div :class="$style.homeHero" class="d-flex" :style="gameHeroStyle">
        <b-container>
          <div :class="$style.heroContent">
            <div class="d-flex mt-5" />
            <h1 class="heading-2">
              {{ $t("games.title") }}
            </h1>
            <p class="px-lg-5 d-inline-block">
              {{ $t("games.desp") }}
            </p>
          </div>
        </b-container>
      </div>
    </div>

    <div
      :class="$style.blogBlock"
      class="d-flex flex-column w-100 bg-lightYellow"
    >
      <b-container>
        <div :class="$style.setOnTop">
          <b-row align-h="center">
            <b-col
              v-for="(data, index) in featureGame"
              :key="index"
              class="mb-4"
              cols="12"
              sm="12"
              md="6"
              lg="6"
              xl="6"
            >
              <GameCoverCard :data="data" class="mb-1" />
            </b-col>
          </b-row>
          <b-row>
            <b-col
              v-for="(data, index) in currentGameList"
              :key="index"
              class="mb-4"
              cols="12"
              md="6"
              lg="4"
              xl="4"
            >
              <ColorCard :data="data" class="mb-1" v-if="data.isColorCard" />
              <RecommendationCard :data="data" class="mb-1" v-else />
            </b-col>
          </b-row>
        </div>

        <div class="d-inline-block w-100 text-center mt-4">
          <button
            class="btn btn-primary btn-x"
            type="button"
            @click="getMoreGames"
            v-if="showButton"
            id="showMore"
          >
            {{ this.$t("games.show") }}
          </button>
        </div>
      </b-container>
    </div>

    <div class="w-100 d-inline-block">
      <HelpSupport />
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.homeHero {
  position: relative;
  height: 500px;
  background-color: $bg-light-skye-blue;
  //background-image: url("~@/assets/images/panda-foot-pattern@2x.png");
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: cover;
  .heroContent {
    text-align: center;
    width: 670px;
    max-width: 100%;
    margin: 200px auto 0;
    h1 {
      margin-bottom: 30px;
    }
    p {
      margin-bottom: 40px;
    }
  }
}

.blogBlock {
  padding-bottom: 60px;
  .setOnTop {
    margin-top: -135px;
  }
}

@media only screen and (max-width: 767px) {
  .homeHero {
    .heroContent {
      margin: 121px auto 0;
    }
  }
}
</style>
